import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faBars } from "@fortawesome/free-solid-svg-icons"

export const Bars = (props) => {
  return <FontAwesomeIcon faIcon={faBars} {...props} />
}
